// services/userAPI.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;
const API_URL = '/users'; // Assuming your users API endpoint is '/users'

export const fetchUsers = async (adminId) => {
    const response = await axios.get(`${BASE_URL}${API_URL}`, {
        params: { adminId }, // Send adminId as a query parameter
      });
      return response.data;
};
